export const INPUT_NAMES = {
  FULL_NAME: 'fullname',
  EMAIL: 'email'
}
